
<ng-container *ngIf="!isDeleted">
    <div class="site-container detail_page_public" [ngClass]="{'no-padding': isEmbedMode}">
        <!-- START HEADER-->
        <app-external-header *ngIf="!isEmbedMode"></app-external-header>
    
        <!-- CLOSE HEADER-->
        <ng-container *ngIf="!storyDetail?.isNoPermission">
            <!-- START CONTENT-->
            <div class="b-story spacer">
                <div class="b-story-head">
                    <app-pb-author-informations class="b-story-head__author mr-auto"></app-pb-author-informations>
                    <!-- <app-pb-story-toolbar *ngIf="!isEmbedMode"></app-pb-story-toolbar>
                    <skeleton-pb-story-toolbar *ngIf="!isEmbedMode"></skeleton-pb-story-toolbar> -->
                </div>
            </div>
            <div class="b-story-body">
              <div class="contributor_container" *ngIf="!isSmallScreen">
                <app-pb-contributor-list ></app-pb-contributor-list>
              </div> 
                <div class="m-story-main">
                  <app-pb-steps-bar *ngIf="isSmallScreen" class="m-story-tags d-block"></app-pb-steps-bar>
                    <div class="m-story-content">
                        <div class="m-story-content__inner">
                            <div class="m-story-content__banner" *ngIf="storyDetail?.media">
                              <div class="slideshow-container" style="background-position: center bottom;" [style.background-image]="backgroundImageUrl">
                                <div class="mySlides" *ngFor="let item of mediaPayload ; let i= index" [ngClass]="{'fade': i == activeIndex,'hidedisplay':i != activeIndex, 'showDisplay': i == activeIndex}">
                                  <ng-container *ngIf="!isVideo(item.type)">
                                    <img [src]="item.imageUrl" />
                                  </ng-container>
                                  <ng-container *ngIf="isVideo(item.type)">
                                    <!-- <video-control [src]="storyDetail.media.fullsize" [type]="storyDetail.media.saveIn"></video-control> -->
                                    <!-- <iframe id="detail-private-board_iframe" [src]="item.url" width="100%" frameBorder="0"></iframe> -->
                                    <mux-player  stream-type="on-demand"
                                    default-hidden-captions 
                                    attr.playback-id='{{item.url}}' attr.title="{{item.title}}" attr.poster="{{item.thumbnail_url}}"
                                    attr.primary-color="{{primaryColor}}"
                                    attr.accent-color="{{accentColor}}">
                                  </mux-player>
                                  <!-- <div class="group-action">
                                    <div>
                                      <button class="btn-action" (click)="downloadVideo(item)" title="Download Video">
                                        <i class="fa-solid fa-download"></i>
                                      </button>
                                    </div>
                                  </div> -->
                      
                                  </ng-container>
                                </div>
                                <!-- <a class="prev" (click)="plusSlides(-1)" *ngIf="mediaPayload.length > 1"> <span class="previous_slide">❮</span></a>
                                <a class="next" (click)="plusSlides(1)" *ngIf="mediaPayload.length > 1"><span class="next_slide">❯</span></a> -->

                            </div>
                            </div>
                            <div class="m-story-content__banner" [hidden]="!statusDetail.isLoading">
                                <gs-skeleton-loader height="500"></gs-skeleton-loader>
                            </div>

                            <div style="text-align:center" *ngIf="storyDetail?.media && storyDetail?.media.length">
                              <span class="dot" (click)="currentSlide(i)"  *ngFor="let item of mediaPayload ; let i = index" [ngClass]="{'showIndiacatr': i == activeIndex}"></span> 
                              <!-- <span class="dot" (click)="currentSlide(item)"></span> 
                              <span class="dot" (click)="currentSlide(item)"></span>  -->
                            </div>
                            <div class="m-story-content__content">
                                <h1 class="m-story-content__content-title">{{storyDetail?.title}}</h1>
                                <ng-container *ngIf="showQuestion && storyDetail?.show_prompt">
                                    <div class ="stroy-prompt" > {{showQuestion}}
                                    </div>
                                  </ng-container>
                                <!-- <div class="m-story-content__content-post" [innerHtml]="storyDetail?.content"></div> -->
                                <ng-container *ngIf="storyDetail && !interviewcontent && !interviewcontent.length">
                                  <quill-editor [(ngModel)]="quillData" theme="bubble" [placeholder]="' '"
                                  [modules]="quillModule" [readOnly]="true"></quill-editor>
                                </ng-container>
                
                                <ng-container *ngIf="storyDetail && interviewcontent && interviewcontent.length && storyDetail?.show_prompt && showPromptonInterviewStyle">
                                  <ng-container *ngFor="let item of interviewcontent ; let i = index ">
                                    <div class="interview_contet" *ngIf="item.body">
                                      <ng-container *ngIf="item.body">
                                        <span *ngIf="storyDetail?.show_prompt && showPromptonInterviewStyle" class="stroy-prompt">
                                          {{item.question}}
                                         </span> <br *ngIf="storyDetail?.show_prompt && showPromptonInterviewStyle"/>
                                         <quill-editor [(ngModel)]="item.body" theme="bubble" [placeholder]="' '"
                                         [modules]="quillModule" [readOnly]="true"></quill-editor>
                                      </ng-container>
                                    </div>
                                  </ng-container>

                          
                                </ng-container>
                                <ng-container *ngIf="storyDetail  && storyDetail?.interview_style &&  (!storyDetail?.show_prompt ||  !showPromptonInterviewStyle)">
                                  <quill-editor [(ngModel)]="quillData" theme="bubble" [placeholder]="' '"
                                  [modules]="quillModule" [readOnly]="true"></quill-editor>
                                </ng-container>
                                <gs-skeleton-loader class="m-story-content__content-title" width="500" height="44"
                                    [hidden]="!statusDetail.isLoading">
                                </gs-skeleton-loader>
                                <gs-skeleton-loader [hidden]="!statusDetail.isLoading"
                                    class="m-story-content__content-post">
                                </gs-skeleton-loader>
                                <gs-skeleton-loader [hidden]="!statusDetail.isLoading"
                                    class="m-story-content__content-post">
                                </gs-skeleton-loader>
                                <gs-skeleton-loader [hidden]="!statusDetail.isLoading"
                                    class="m-story-content__content-post">
                                </gs-skeleton-loader>
                            </div>
                            <app-pb-nudge-preview></app-pb-nudge-preview>
                        </div>
                    </div>
                    <div class="detail_steps_bar" [ngStyle]="{'width': no_Tags ? '17%' : ''}" *ngIf="!isSmallScreen">
                      <app-pb-steps-bar  class="m-story-tags d-block"></app-pb-steps-bar>
                    </div>
 
                    <div class="m-story-aside" style="width: 25rem;">
                        <app-pb-contributor-list *ngIf="isSmallScreen"></app-pb-contributor-list>
                        <!-- <div class="m-story-comments"></div> -->
                        <!-- <app-pb-comment-list></app-pb-comment-list> -->
                    </div>
                </div>
            </div>
            <!-- CLOSE CONTENT-->
        </ng-container>
    
        <app-pb-no-permision-content *ngIf="storyDetail?.isNoPermission || storyDetail?.archived">
        </app-pb-no-permision-content>
    </div>
    <ng-container *ngIf="showEntireProcess">
      <div class="remark-box"  *ngIf="!isSmallScreen && showmessagebody">

        <div class="remark-container">
          <div class="close__popup_Design" (click)="showMessage()">
            <span >
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
          </div>
      
          <div class="row">
            <!-- <div class="col-2  ml-4 unique paddings">
              <gs-avatar  [src]="removeUrl(messageData.author?.avatar)" classCss="avatar"></gs-avatar>
            </div> -->
          <div class="col-8  ml-4">
            <!-- Debug Info - Remove this after testing -->
            <!-- <div style="background: #f0f0f0; padding: 10px; margin: 10px 0; font-size: 12px;">
              <strong>Debug Info:</strong><br>
              messageData: {{messageData | json}}<br>
              is_video: {{messageData.is_video}}<br>
              asset_id: {{messageData.asset_id}}<br>
              video_asset_id: {{messageData.video_asset_id}}<br>
              video_url: {{messageData.video_url}}
            </div>
             -->
            <!-- Video Message Display -->
            <div class="video_container" *ngIf="messageData.playback_id">
              <mux-player stream-type="on-demand"
                default-hidden-captions 
                [attr.playback-id]="messageData.playback_id" 
                [attr.title]="messageData.author?.display_name + ' - Personal Message'"
                [attr.primary-color]="primaryColor"
                [attr.accent-color]="accentColor"
                style="width: 100%; max-width: 400px;">
              </mux-player>
            </div>
            
            <!-- Text Message Display -->
            <p class="content-data" *ngIf="messageData.message">{{messageData.message}}</p>
            <p class="content-created">-{{messageData.author?.display_name}}</p>
          </div>
          </div>
        
        </div>
      
      </div>
      
      <div class="remark-box--mobile" *ngIf="isSmallScreen && showmessagebody">
      
        <div class="remark-container">
          <div class="close__popup_Design" (click)="showMessage()">
            <span >
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
          </div>
          <div class="row">
            <!-- <div class="col-3 ml-4 unique paddings">
              <gs-avatar  [src]="removeUrl(messageData.author?.avatar)" classCss="avatar"></gs-avatar>
            </div> -->
          <div class="col-8   ml-4">
            <!-- Video Message Display -->
            <div class="video_container" *ngIf="messageData.playback_id">
              <mux-player stream-type="on-demand"
                default-hidden-captions 
                [attr.playback-id]="messageData.playback_id" 
                [attr.title]="messageData.author?.display_name + ' - Personal Message'"
                [attr.primary-color]="primaryColor"
                [attr.accent-color]="accentColor"
                style="width: 100%; max-width: 300px;">
              </mux-player>
            </div>
            
            <!-- Text Message Display -->
            <p class="content-data" *ngIf="messageData.message">{{messageData.message}}</p>
            <p class="content-created">-{{messageData.author?.display_name}}</p>
          </div>
          </div>
        
        </div>
      
      </div>

      <div class="meesage__remarkbox" *ngIf="showMessageBx && !isSmallScreen" (click)="showMessage()">
        <div *ngIf="isnotSeen" class="avatar_show unique">
          <div class="red_notiication anim-pulse-cta"></div>
          <gs-avatar  [src]="removeUrl(messageData?.author?.avatar)"  classCss="avatar"></gs-avatar>
        </div>
    
        <div *ngIf="!isnotSeen" class="avatar_show unique">
          <div class="red_notiication"></div>
          <gs-avatar  [src]="removeUrl(messageData?.author?.avatar)"  classCss="avatar"></gs-avatar>
        </div>
      </div>
      
      <div class="meesage__remarkbox__mobile" *ngIf="showMessageBx && isSmallScreen" (click)="showMessage()">
        <div *ngIf="isnotSeen" class="avatar_show unique">
          <div class="red_notiication anim-pulse-cta"></div>
          <gs-avatar  [src]="removeUrl(messageData?.author?.avatar)"  classCss="avatar"></gs-avatar>
        </div>
    
        <div *ngIf="!isnotSeen" class="avatar_show unique">
          <div class="red_notiication"></div>
          <gs-avatar  [src]="removeUrl(messageData?.author?.avatar)"  classCss="avatar"></gs-avatar>
        </div>
      </div>
    </ng-container>

    <app-site-footer></app-site-footer>  
</ng-container>

<div id="downloadfile"></div>